<template>
  <v-container id="reference-term-list">
    <v-row>
      <v-col cols="8" md="8" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>

      <v-col cols="4" sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-insert-group-solution
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="loadGroupSolutions"
            >
              <template v-slot:title>
                Cadastramento de
                {{ isAT ? "Grupo de Iniciativa" : "Grupo de Solução" }}
              </template>
            </app-modal-insert-group-solution>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="groupSolutions"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="4">
                <app-modal-insert-group-solution
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @onSave="loadGroupSolutions"
                >
                  <template v-slot:title>
                    Edição de
                    {{ isAT ? "Grupo de Iniciativa" : "Grupo de Solução" }}
                  </template>
                </app-modal-insert-group-solution>
              </v-col>

              <v-col cols="4">
                <app-modal-delete-group-solution
                  :payload="item"
                  @onDelete="loadGroupSolutions"
                >
                  <template v-slot:title>
                    Deletar
                    {{ isAT ? "Grupo de Iniciativa" : "Grupo de Solução" }}
                  </template>
                </app-modal-delete-group-solution>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { groupSolutionAPI } from "../API/GroupSolutionAPI";
import AppModalInsertGroupSolution from "./ModalInsert";
import AppModalDeleteGroupSolution from "./ModalDelete";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppSolutionList",
  components: {
    AppModalInsertGroupSolution,
    AppModalDeleteGroupSolution,
  },
  data() {
    return {
      headers: [
        {
          text: "#",
          value: "grupoSolucaoId",
          sortable: false,
        },
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "eixo",
        },
      ],
      groupSolutions: [],
    };
  },
  mounted() {
    if (this.isAT) {
      this.breadcrumbs = [
        {
          text: "Grupos de Iniciativas",
          disabled: true,
          href: "eixo",
        },
      ];
    }
    this.loadGroupSolutions();
  },
  computed: {
    ...mapGetters(["loading", "isAT"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadGroupSolutions() {
      this.setLoading(true);
      groupSolutionAPI
        .list()
        .then((resp) => {
          this.groupSolutions = resp.data;
          this.setLoading(false);
          this.$emit("reload");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao listar ${
              this.isAT ? "Grupo de Iniciativa" : "Grupo de Solução"
            }`
          );
        });
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
